module.exports = __webpack_public_path__ + "static/media/dark-more.2f163e44.svg";